(function( $ ) {

    $.fn.activity_indicator = function( options ) {

        var settings = $.extend({
          buttonText: null,
          class: null
        }, options)

        return $(this).on("click", function(e){

          if ( $(this).hasClass("button-disabled") ) {

            e.preventDefault()

          } else {

            $(this)
              .text(settings.buttonText)
              .prepend('<i class="fa fa-refresh fa-spin space-right"></i>')
              .addClass('button-disabled')

          }



        })

    };

}( jQuery ));
